//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseItemPost from './BaseItemPost.vue';

export default {
    components: {
        BaseItemPost,
    },

    props: {
        data: {
            type: Array,
            required: true,
        },
    },
};
